import React, { useState, useEffect } from 'react';
import { api } from '@/api/apiClient';
import { createPageUrl } from '@/utils';
import { Loader2 } from 'lucide-react';

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    redirectToDashboard();
  }, []);

  const redirectToDashboard = async () => {
    try {
      const user = await api.auth.me();
      const userRole = user.user_role || 'employee';

      // Check if employee and hasn't seen welcome
      if (userRole === 'employee') {
        const employees = await api.entities.Employee.filter({ user_email: user.email });
        if (employees.length > 0 && !employees[0].has_seen_welcome) {
          window.location.href = createPageUrl('Welcome');
          return;
        }
      }

      // Redirect based on role
      const dashboards = {
        admin: 'AdminDashboard',
        sub_admin: 'EmployerDashboard',
        employer_hr: 'EmployerDashboard',
        employee: 'EmployeeDashboard'
      };

      const targetPage = dashboards[userRole] || 'EmployeeDashboard';
      window.location.href = createPageUrl(targetPage);
    } catch (err) {
      console.error(err);
      window.location.href = createPageUrl('Welcome');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
        <p className="text-slate-600 font-medium">Loading your dashboard...</p>
      </div>
    </div>
  );
}